import { render, staticRenderFns } from "./cadtiposcobranca.vue?vue&type=template&id=9ad5eaf6&"
import script from "./cadtiposcobranca.vue?vue&type=script&lang=js&"
export * from "./cadtiposcobranca.vue?vue&type=script&lang=js&"
import style0 from "./cadtiposcobranca.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports